import { Component } from '@angular/core';

@Component({
  selector: 'crowdctrl-shared',
  imports: [],
  template: ` <p>shared works!</p> `,
  styles: ``,
})
export class SharedComponent {}
